import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73384c19"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "primary-modal-header" }
const _hoisted_2 = { class: "primary-modal-content" }
const _hoisted_3 = { class: "primary-modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    appear: "",
    name: "primary-modal"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.isLightMode() ? 'primary-modal' : 'primary-modal-dark'),
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClickModalBackground && _ctx.onClickModalBackground(...args)), ["self"]))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.isLightMode() ? 'primary-modal-window' : 'primary-modal-dark-window')
        }, [
          _createElementVNode("header", _hoisted_1, [
            _renderSlot(_ctx.$slots, "header", {}, undefined, true)
          ]),
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]),
          _createElementVNode("footer", _hoisted_3, [
            _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
          ])
        ], 2)
      ], 2)
    ]),
    _: 3
  }))
}